var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userAccount)?_c('div',{staticClass:"sm-account-cont"},[_c('account-upper'),_c('account-main')],1):_c('sm-spinner',{attrs:{"show":!_vm.userAccount}})
}
var staticRenderFns = []

export { render, staticRenderFns }